/**
 * Risk Matrix Modal Component
 * 
 * Visual Risk Matrix for selecting Objective Risk Ranking
 * Used in Tab 2 - Objectives and Risks
 * 
 * Features:
 * - 5x5 matrix (Likelihood vs Impact Severity)
 * - Clickable cells that return risk level (High, Med, Low)
 * - Auto-close on selection
 */

import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import styled from 'styled-components';
import { RootState } from '../store';

// ========== TYPES ==========

interface ReportRolloverModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

// ========== STYLED COMPONENTS ==========

const ModalContent = styled.div`
`;

const MatrixTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  color: #1F2937;
  margin-bottom: 16px;
  text-align: center;
`;

const MatrixDescription = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #6B7280;
  margin-bottom: 24px;
  text-align: center;
`;


// ========== COMPONENT ==========

const ReportRolloverModal: React.FC<ReportRolloverModalProps> = ({
  open,
  onClose,
  onSubmit
}) => {
 
  const { selectedReport } = useSelector((state: RootState) => state.annualReport);
  const [isRollingOver, setIsRollingOver] = useState(false);

  const rolloverReport = () => {
    setIsRollingOver(true);
    onSubmit();
  }
 
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      styles={{
        body: {
          padding: '24px',
        },
      }}
    >
      <ModalContent>
        <MatrixTitle>Project Fiscal Year Rollover</MatrixTitle>
        <MatrixDescription>
          Do you wish to rollover the currently selected fiscal year ({selectedReport?.year ?? 0} {'->'} {(selectedReport?.year ?? 0) + 1})? This will generate a new report for the following year, retaining only the relevant data. 
          <br/><br/>
          This process cannot be undone! Please ensure the current report is complete before rolling over to the next year. 
          <br/><br/>
          This process could take a couple of minutes.
        </MatrixDescription>
        <div style={{display:"flex", justifyContent:"center"}}>
          <Button
                type="primary"
                onClick={rolloverReport}
                style={{ marginTop: 10 }}
                loading={isRollingOver}
              >
                Rollover Fiscal Year
              </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ReportRolloverModal;

